module.exports = __webpack_public_path__ + "img/cooperative0_logo18.8f29f323.jpg";